export var TableKeyEnum;
(function (TableKeyEnum) {
    TableKeyEnum["projectList"] = "projectList";
    TableKeyEnum["estimateBOQ"] = "estimateBOQ";
    TableKeyEnum["estimateSolutions"] = "estimateSolutions";
})(TableKeyEnum || (TableKeyEnum = {}));
